
import React from 'react'


// import blanketdisrtibution from "../images/Blanket Distribution 26th December 2024.jpeg";


function UpdateE() {
    return (
        <div>
            <div className="album py-3">
                <div className="container">
                    <div className="row">

                        <div className="col-md-4 mt-2">
                            <br />
                            <br />
                            <br />
                            <a href='CompleteEvent'>
                                <div className='btn-grad134'> Completed Events Bulletin</div>
                            </a>
                        </div>
                        <div className="col-md-8">
                            <div className='schoolberhampore'>
                                <h2 className='blink mt-2' >M.I.S.A.A <b>Upcoming Events Bulletin</b> :</h2>
                                <hr />
                            </div>
                            <div className="card" >
                                <div class="card-header">
                                    <center> <h3 style={{ color: "red" }} className='blink'></h3> </center></div>
                                      
                                {/* <img src={blanketdisrtibution} className="card-img-top mb-2" alt="blanketdisrtibution26thdecember2024"/> */}
                                {/* <img src={misaaelection2024} className="card-img-top" alt="misaaelection2024"/> */}
                                <div className="card-body">
    <h5 className='mt-0' style={{color:"Darkblue"}}>This winter 2025,  Mary Immaculate School Alumni Association will have it's Annual Get-together, Grand Musical night & Gala dinner on 21st of December, Sunday, at M.I.S. Warm welcome to all M.I.S.A.A members 🧡</h5>
    <p className='mb-1 mt-2'><b>Some relevant informations :</b></p>
<p>
1) The revised annual renewal charges of M.I.S.A.A are 600/- INR only, from this year 2025. </p>
<p>2) To become a new M.I.S.A.A member, ( ordinary ) revised one time charges are 800/- INR only, from this year 2025.</p>
<p>4) M.I.S.A.A members who have membership renewals due for 3 or more years, PAY RENEWALS NOW FOR JUST 2 YEARS @600/- PER YEAR and get your membership renewed upto date.</p>
<p>5) The annual friendly football match between M.I.S.A.A XI and M.I.S XI will be held on the afternoon ( 2 PM ) of the same day as our annual get-together that is on 21st December at M.I.S grounds.</p>

<h6><b>Please spread the word to all your M.I.S friends & peers.</b></h6>                                    {/* <p style={{color:"grey"}} className='mb-0 mt-0'>Blanket Distribution to Orphan Children of Bharat Sevasram, Chuanpur, Berhampore. 26th December 2024, 03:00 PM</p> */}
                                </div>
                            </div>

                        </div>
                    </div >
                </div >
            </div >
        </div >
    )
}

export default UpdateE
